module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--euro-d62ffe64fb34a832769f12964deacd36.jpg";